import "./App.css";

import Menu from "./Components/Menu";
import Header from "./Components/Header";
import Hello from "./Components/Hello";
import Resume from "./Components/Resume";
import Skills from "./Components/Skills";
import Contact from "./Components/Contact";
import CommunityContributions from "./Components/CommunityContributions";

function App() {
  return (
    <div className="app">
      <Menu />
      <Header />
      <Hello />
      <Resume />
      <CommunityContributions />
      <Skills />
      <Contact />
    </div>
  );
}

export default App;
